import { Component, EventEmitter, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import * as fromServices from '../../services';
import { HttpParams } from '@angular/common/http';

@Component({
  selector: 'hdw-filter-by',
  templateUrl: './filter-by.component.html',
  styleUrls: ['./filter-by.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class FilterByComponent implements OnInit {
  public checkboxData: { name: string; value: string; selected: boolean; }[];
  private filterByChange = new Subject<string>();
  public isOrganTransplantType: boolean;
  public organTransplantFormGroup: FormGroup;
  public filterByName: string;
  public canShowOrganSelection: boolean = false;
  public programTypes: fromServices.TransplantProgram[];
  @Output() filterByEmitter: EventEmitter<{
    filterBy: string;
    checkboxData?: { name: string; value: string; selected: boolean; }[];
  }>;

  constructor(
    private toolIdentifierService: fromServices.ToolIdentifierService,
    private fb: FormBuilder,
    private filterService: fromServices.FilterService
  ) {
    this.filterByEmitter = new EventEmitter<{
      filterBy: string;
      checkboxData?: { name: string; value: string; selected: boolean; }[];
    }>();
    this.filterByChange = new Subject<string>();
  }

  public ngOnInit(): void {
    this.initToolType();
    this.initFilterBy();
    if (this.isOrganTransplantType) {
      this.organTransplantFormGroup = this.fb.group({
        "all": new FormControl(false)
      });
      this.filterService
        .getTransplantPrograms()
        .subscribe(programs => {
          this.programTypes = programs;
          this.initFormGroup();
          this.checkForFilterParams();
        });
    }
  }

  private checkForFilterParams() {
    const url = window.location.href;
    if (url.includes('?')) {
      const httpParams = new HttpParams({ fromString: url.split('?')[1] });
      const otp = httpParams.get('type');
      if (otp) {
        const program = this.programTypes.find(t => t.ServiceType.toLowerCase() == otp.toLowerCase());
        if (program) {
          this.organTransplantFormGroup.get(`otp${program.Id}`).setValue(true);
          this.handleCheckboxClick(`otp${program.Id}`);
        }
      }
    }
  }

  private initToolType(): void {
    this.isOrganTransplantType =
      this.toolIdentifierService.getCurrentTool() === fromServices.LocatorTools.OrganTransplantCenter;
  }

  private initFormGroup(): void {
    let controls = {
      "all": new FormControl(false)
    };
    for (const organType of this.programTypes) {
      controls[`otp${organType.Id}`] = new FormControl(false);
    }
    this.organTransplantFormGroup = this.fb.group(controls);
  }

  private initFilterBy(): void {
    this.filterByChange.pipe(debounceTime(500)).subscribe(value => {
      const emittedValue = { filterBy: this.filterByName, checkboxData: null };
      if (this.isOrganTransplantType) {
        emittedValue.checkboxData = this.checkboxData;
      }
      this.filterByEmitter.emit(emittedValue);
    });
  }

  public handleFilterBy(filterBy: string): void {
    this.filterByChange.next(filterBy);
  }

  public handleOrganSelection(): void {
    this.canShowOrganSelection = !this.canShowOrganSelection;
  }

  public handleCheckboxClick(id: string): void {
    if (id === 'all') {
      const value = this.organTransplantFormGroup.controls['all'].value;
      Object.keys(this.organTransplantFormGroup.controls).forEach(controlName => {
        this.organTransplantFormGroup.get(controlName)?.setValue(value);
      });
    }
    else {
      if (!this.organTransplantFormGroup.get(id).value)
        this.organTransplantFormGroup.get('all')?.setValue(false)
    }
    this.buildCheckboxData();
  }

  private buildCheckboxData(): void {
    this.checkboxData = [];
    Object.keys(this.organTransplantFormGroup.controls).forEach(controlName => {
      const cbValue = controlName === 'all' ? '' 
        : this.programTypes.find(i => i.Id == controlName.substring(3))?.ServiceType;
      const cb = { 
        name: controlName, 
        selected: this.organTransplantFormGroup.get(controlName).value, 
        value: cbValue
      };
      this.checkboxData.push(cb);
    });
    const emittedValue = {
      filterBy: this.filterByName,
      checkboxData: this.checkboxData
    };
    this.filterByEmitter.emit(emittedValue);
    console.log(this.organTransplantFormGroup);
  }
}
